import Compose from './Compose';

export default Compose;
